export default "__VITE_ASSET__Bf6xadyI__"